module.exports = __webpack_public_path__ + "media/images/service/service-deatils-84f6a9d77f24e2f5b147abe2f70911b7.png";